"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentRequestButton = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _reactStripeJs = require("@stripe/react-stripe-js");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("amountValue", _flowRuntime["default"].string()), _flowRuntime["default"].property("onSuccess", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"].any()))), _flowRuntime["default"].property("paymentIntentSecret", _flowRuntime["default"].string()), _flowRuntime["default"].property("setPaymentError", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"].any()))), _flowRuntime["default"].property("setSubmitting", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"]["return"](_flowRuntime["default"].any()))), _flowRuntime["default"].property("stripe", _flowRuntime["default"].any())));

var PaymentRequestButton = function PaymentRequestButton(_arg) {
  var amountValue = _arg.amountValue,
      onSuccess = _arg.onSuccess,
      paymentIntentSecret = _arg.paymentIntentSecret,
      setPaymentError = _arg.setPaymentError,
      setSubmitting = _arg.setSubmitting,
      stripe = _arg.stripe;

  var onPaymentRequest = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(event) {
      var _yield$stripe$confirm, paymentIntent, confirmError, _yield$stripe$confirm2, error;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return stripe.confirmCardPayment(paymentIntentSecret, {
                payment_method: event.paymentMethod.id
              }, {
                handleActions: false
              });

            case 2:
              _yield$stripe$confirm = _context.sent;
              paymentIntent = _yield$stripe$confirm.paymentIntent;
              confirmError = _yield$stripe$confirm.error;

              if (!confirmError) {
                _context.next = 9;
                break;
              }

              // Report to the browser that the payment failed, prompting it to
              // re-show the payment interface, or show an error message and close
              // the payment interface.
              event.complete('fail');
              _context.next = 20;
              break;

            case 9:
              // Report to the browser that the confirmation was successful, prompting
              // it to close the browser payment method collection interface.
              event.complete('success'); // Check if the PaymentIntent requires any actions and if so let Stripe.js
              // handle the flow. If using an API version older than "2019-02-11"
              // instead check for: `paymentIntent.status === "requires_source_action"`.

              if (!(paymentIntent.status === 'requires_action')) {
                _context.next = 18;
                break;
              }

              _context.next = 13;
              return stripe.confirmCardPayment(paymentIntentSecret);

            case 13:
              _yield$stripe$confirm2 = _context.sent;
              error = _yield$stripe$confirm2.error;

              if (error) {
                setPaymentError(error.message);
                setSubmitting(false); // The payment failed -- ask your customer for a new payment method.
              } else {
                // The payment has succeeded.
                setSubmitting(false);
                onSuccess(paymentIntent.id);
              }

              _context.next = 20;
              break;

            case 18:
              // The payment has succeeded.
              setSubmitting(false);
              onSuccess(paymentIntent.id);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onPaymentRequest(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      paymentRequest = _useState2[0],
      setPaymentRequest = _useState2[1];

  (0, _react.useEffect)(function () {
    if (stripe) {
      var pr = stripe.paymentRequest({
        country: 'GB',
        currency: 'gbp',
        total: {
          label: 'Total',
          amount: parseInt(amountValue, 10)
        },
        requestPayerName: true,
        requestPayerEmail: true
      }); // Check the availability of the Payment Request API.

      pr.canMakePayment().then(function (result) {
        if (result) {
          setPaymentRequest(pr);
        }
      });
    }
  }, [amountValue, stripe]);
  var options;

  if (paymentRequest) {
    paymentRequest.on('paymentmethod', /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(event) {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                onPaymentRequest(event);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    options = {
      paymentRequest: paymentRequest,
      style: {
        paymentRequestButton: {
          type: 'donate',
          // One of 'default', 'book', 'buy', or 'donate'
          // Defaults to 'default'
          theme: 'dark',
          // One of 'dark', 'light', or 'light-outline'
          // Defaults to 'dark'
          height: '64px' // Defaults to '40px'. The width is always '100%'.

        }
      }
    };
  }

  return paymentRequest ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-method-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("h3", null, /*#__PURE__*/_react["default"].createElement("span", null, "Quick Payment")), /*#__PURE__*/_react["default"].createElement(_reactStripeJs.PaymentRequestButtonElement, {
    options: options
  })), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "separator"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "OR"))) : null;
};

exports.PaymentRequestButton = PaymentRequestButton;